export const ui = {
// ── SIDEBAR NAVIGATION ───────────────────────────────────────

'nav_chapter_health_intelligence': 'STEUERE DEINE GESUNDHEIT',
'nav_chapter_health_pillars': 'SÄULEN DEINER GESUNDHEIT',
'nav_chapter_test_results': 'TESTERGEBNISSE',
'nav_chapter_utilities_apps': 'APPS FÜR DEINE GESUNDHEIT',
'nav_chapter_account': 'ADMINISTRATION',

'nav_welcome': 'Willkommen',
'welcome_vision': 'Auf Basis standardisierter Labortests und in Zusammenarbeit mit Wissenschaft, Präventivmedizinern und Molekularbiologen wandelt speak23 deine Gesundheitsdaten in nutzbare, schnell umsetzbare und personalisierte Empfehlungen – für mehr gesunde Jahre.',
'welcome_pattern_intro': 'Die speak23 Software prüft nicht nur das Offensichtliche – Marker im Normalbereich. Die Software sucht auch nach Mustern, die Routineberichte oft verbergen:',
'welcome_pattern_item1': 'Frühe Veränderungen im Stoffwechsel – Jahre bevor ein Wert in den roten Bereich fällt',
'welcome_pattern_item2': 'Niederschwellige versteckte chronische Entzündungen, die das Altern unbemerkt beschleunigt',
'welcome_pattern_item3': '"Immune-Aging" – wird in allgemeinen Vorsorgeuntersuchungen kaum überprüft',
'welcome_tour_header': 'Noch nicht vertraut mit der speak23 Software?',
'welcome_tour_prompt': 'Starte eine kurze Tour und lerne die wichtigsten Bereichen der Software kennen. Wir zeigen dir Schritt für Schritt, was du wo findest — und was deine Werte für deine Gesundheit bedeuten.',
'welcome_tour_intro': '',
'welcome_aging_header': 'Akzeptiere schnelles Altern nicht',
'welcome_aging_text': 'Die Grundlage für gesunde Langlebigkeit sind Schlaf, Ernährung und Bewegung. Regelmäßiges Muskeltraining hilft gegen Verlust von Muskelmasse im Alter. Wenn du einige dieser Prinizipien in deinen Lifestyle integrierst, ist der Nutzen von speak23 Software am größten. Dein "biologisches Alter" ist eine gute Orientierung für dich.',
'welcome_aging_text2': 'Die speak23 Software zeigt dir, ob du bei Vitaminen oder Mineralien durch Ernährungsanpassung oder Supplementierung deine Gesundheit optimieren kannst (ein optimaler Omega-3 Index ist ein gutes Beispiel dafür).',
'welcome_section_header': 'Was dich hier erwartet:',
'welcome_section_subheader': 'Links oben neben dem Logo befindet sich die Schaltfläche, mit der sich die Menüleiste für die Applikation öffnen und schliessen lässt. Diese Navigationsleiste ist deine wichtigste Orientierung für alle Funktionen der Applikation. Sie teilt sich in 4 Bereiche:',
'welcome_box1_title': 'Steuere deine Gesundheit',
'welcome_box1_item1': 'speak23 analysiert die Gesundheit anhand der 4 Pfeiler Stoffwechsel, Immunsystem, Organe und (Mikro-)Nährstoffe. Für jeden dieser 4 Grundpfeiler der Gesundheit findest du in diesem Bereich eine eigene Seite mit deinen Auswertungen.',
'welcome_box1_item2': 'Im Cockpit findest du eine Zusammenfassung aller Auswertungen, personalisierte Empfehlungen und einen Vorschlag für dein nächstes Arztgespräch.',
'welcome_box2_title': 'Deine Testergebnisse',
'welcome_box2_item1': 'Hier befinden sich deine Ergebnisse vom Laborbesuch. Es werden alle Informationen zum Laborbesuch angezeigt, die Resultate sind geordnet nach ausgewählten Tests. Der Core Health Bluttest ist immer an erster Stelle, optionale Addon-Pakete folgen darunter. Du siehst sofort, wieviele Marker im jeweiligen Paket Beachtung brauchen.',
'welcome_box2_item2': 'Wenn du das Addon "Biologisches Alter" bestellt hast, findest du dafür eine eigene Analyseseite.',
'welcome_box2_item3': 'Falls du als Frau das Hormonpaket oder das Paket Eizellreserve bestellt hast, gibt es dafür eine eigene Seite mit tiefergehender Analyse (nur für Frauen).',
'welcome_box2_item4': 'Dein detaillierter Report für das Darm-Mikrobiom ist in diesem Abschnitt der letzte Menüpunkt, sofern dieser Report von dir bestellt wurde.',
'welcome_box3_title': 'Weitere Applikationen für deine Gesundheit',
'welcome_box3_item1': 'Der Bereich Körper & Blutdruck gibt dir die Möglichkeit, Körpergewicht, Taillenumfang, BMI (Body-Mass-Index) und deinen Blutdruck zu dokumentieren und zu steuern.',
'welcome_box3_item2': 'Der Zyklus-Tracker für Frauen wird unter anderem für die Analyse der Blutmarker benötigt und verwendet, speziell für Bereiche wie Hormone.',
'welcome_box3_item3': 'In der Medikamentenliste dokumentierst du deine tägliche Medikamenteneinnahme – sie hilft, Blutwerte richtig zu lesen und auszuwerten.',
'welcome_box3_item4': 'Im Bereich "Historische Laborbefunde" kannst du zusätzliche Dokumente, die du in Papierform vorliegen hast, als PDF oder Foto hochladen. So hast du deine wichtigen Gesundheitsdokumente immer an einem Ort.',
'welcome_box4_title': 'Administration',
'welcome_box4_item1': 'Im Bereich "Laborbesuche" kannst du deine nächsten Laborbesuche administrieren. Du kannst bei jedem weiteren Laborbesuch neben dem Core Health Bluttest auch Zusatzpakete dazunehmen.',
'welcome_box4_item2': 'Im Menüpunkt "Subskription" verwaltest du dein Abonnement und kannst auch deine Zahlungsmethode ändern.',
'welcome_box4_item3': 'Der Bereich "AddOn Käufe" zeigt eine Übersicht über alle Zusatzpakete, die du bisher ausgewählt hast.',
'welcome_box4_item4': 'Der Menüpunkt "Fragebogen Antworten" zeigt dir deine Antworten auf bisher ausgefüllte Fragebögen.',
'welcome_box4_item5': 'In "Persönliche Daten" kannst du deine Daten immer aktuell halten. Besonders wichtig für eine hochwertige Analyse ist für Frauen, hier das richtige Profil auszuwählen bzw. aktuell zu halten.',
'welcome_box4_item6': 'Ändere dein Passwort oft und regelmäßig – dafür gibt es diesen Menüpunkt.',
'welcome_privacy_header': 'Datenschutz und Sicherheit',
'welcome_help_header': 'Wo bekomme ich Hilfe und Unterstützung?',
'welcome_help_text': 'Solltest du Fragen haben, sende einfach eine Mail an office@speak23.com. Wir werden sie gerne beantworten bzw. wir rufen dich auch gerne persönlich zurück, falls du das wünschst. In Kürze werden wir im Bereich Administration einen weiteren Menüpunkt hinzufügen für Hilfe und Lernen rund um Gesundheit.',
'welcome_privacy_text': 'Deine Informationen sind durch branchenübliche Sicherheitsmaßnahmen geschützt. Nur autorisierte Benutzer können gemäß deinen Berechtigungen und den geltenden Datenschutzbestimmungen im Gesundheitswesen auf deine Daten zugreifen.',
'nav_health_summary_cockpit': 'Cockpit - Deine Gesundheit',
'nav_12_mechanisms': '12 Mechanismen',
'nav_biological_age': 'Biologisches Alter',
'nav_omega_details': 'Omega Fettsäuren',
'nav_metabolic_health_cockpit': 'Säule 1 - Stoffwechsel',
'nav_immune_health_cockpit': 'Säule 2 - Immunsystem',
'nav_organ_health_cockpit': 'Säule 3 - Organe',
'nav_micronutrients_health_cockpit': 'Säule 4 - Mikronährstoffe',
'nav_core_health': 'Core Health Bluttest',
'nav_arteriosclerosis_prevention': 'Atherosklerose-Prävention',
'nav_marker_omega_lifestyle': 'Omega-3 Index & Fettsäuren',
'nav_hormones_balance': 'Hormone - Frauen',
'nav_bones_health': 'Knochengesundheit',
'nav_vitamins_nutrients': 'Vitamine & Nährstoffe',
'nav_thyroid_health': 'Schilddrüsengesundheit',
'nav_female_fertility_amh': 'Eizellreserve - Frauen',
'nav_female_fertility_amh2': 'Eizellreserve - Frauen',
'nav_male_prostate_health_psa': 'Prostata Krebsvorsorge',
'nav_stool_cancer_test_fob': 'Darmkrebs Vorsorge / FOB',
'nav_bloodtests': 'Labortests - Ergebnisse',
'nav_stooltests': 'Stuhltests',
'nav_gut_microbiome_report': 'Darm-Mikrobiom-Analyse',
'nav_health_essentials': 'Körper & Blutdruck',
'nav_female_cycle_tracker': 'Zyklus-Tracker',
'nav_your_medication_list': 'Medikamentenliste',
'nav_kit_activation_stool_sample': 'Kit-Aktivierung - Stuhlprobe',
'nav_your_labvisits': 'Laborbesuche',
'nav_your_subscription': 'Subskription',
'nav_your_addon_purchases': 'Add-On-Käufe',
'nav_your_questionnaire_responses': 'Fragebogen Antworten',
'nav_feedback': 'Feedback',
'nav_your_personal_data': 'Persönlichen Daten',
'nav_your_change_password': 'Passwort ändern',

'nav_hormones_balance2': 'Hormone',
'av_female_fertility_amh2': 'Eizellreserve - Frauen',

// ── PAGE HEADERS (headline / specify props) ──────────────────

'page_hl_preventive_health': 'Deine Gesundheit - ',
'page_hl_biometric_vitals': 'BIOMETRISCHE VITALWERTE',
'page_hl_metabolic_health': 'Metabolische Gesundheit',
'page_hl_immune_health': 'Immungesundheit',
'page_hl_organ_health': 'Organfunktion',
'page_hl_micronutrients_health': 'Mikronährstoffe',
'page_hl_bloodmarker': 'CORE HEALTH - ',
'page_hl_athero': 'ATHEROSKLEROSIS - ',
'page_hl_omega': 'OMEGA 3 INDEX - ',
'page_hl_hormon': 'HORMONE - ',
'page_hl_bones': 'KNOCHEN - ',
'page_hl_vitamin': 'VITAMINE - ',
'page_hl_thyr': 'SCHILDDRÜSE - ',
'page_hl_female': 'EINZELLRESERVE - ',
'page_hl_pros': 'PROSTATA - ',
'page_hl_cancer_prevention': 'DARMKREBS - ',
'page_hl_gut': 'DARM-MIKROBIOM - ',

'page_hl_cycle': 'KALENDER - ',
'page_hl_questionnaire': 'FRAGEBOGEN - ',
'page_hl_account': 'KONTO - ',
'page_hl_welcome': 'Willkommen - ',

'page_sp_more_healthy_years': 'mehr gesunde Jahre',
'page_sp_summary': 'Überblick',
'page_sp_mechanisms': '12 Mechanismen',
'page_sp_recommendations': 'Empfehlungen',
'page_sp_doctor_notes': 'Arztgespräch',
'page_sp_body_blood_pressure': 'KÖRPER & BLUTDRUCK',
'page_sp_core_health': 'Bluttest',
'page_sp_arteriosclerosis_prevention': 'PRÄVENTION',
'page_sp_omega_lifestyle': 'FETTSÄUREN PROFIL',
'page_sp_hormones_balance': 'BALANCE',
'page_sp_bones_health': 'GESUNDHEIT',
'page_sp_vitamins_nutrients': 'NÄHRSTOFFE',
'page_sp_thyroid_health': 'GESUNDHEIT',
'page_sp_fertility': 'FRUCHTBARKEIT',
'page_sp_prostate_cancer_prevention': 'KREBSVORSORGE',
'page_sp_fob_stool_test': 'VORSORGE',
'page_sp_gut': 'ANALYSE',
'page_sp_cycle_tracker': 'ZYKLUS-TRACKER',
'page_sp_medication_list': 'MEDIKAMENTENLISTE',
'page_sp_your_subscription': 'DEIN ABONNEMENT',
'page_sp_your_addon_purchases': 'ADD-ON-KÄUFE',
'page_sp_your_responses': 'ANTWORTEN',
'page_sp_personal_data': 'PERSÖNLICHE DATEN',
'page_hl_bloodtests': 'Bluttests - ',
'page_sp_bloodtests': 'Übersicht',
'page_hl_stooltests': 'STUHLTESTS - ',
'page_sp_stooltests': 'ÜBERSICHT',
'bt_select_date': 'Laborbesuch auswählen',
'bt_select_labvisit_date': 'Laborbesuch-Datum auswählen',
'bt_tap_to_download': 'Zum Herunterladen tippen',
'bt_download_reports': 'Herunterladen',
'bt_share_with_doctor': 'Mit Arzt teilen',
'bt_share_action': 'Ergebnisse teilen',
'bt_share_info_text': 'Derzeit in Entwicklung - in Kürze nutzbar. Mit dieser Funktion können Sie Ihre Laborergebnisse sicher mit Ihrem Arzt teilen. Ihr Arzt erhält einen Link, um Ihre Ergebnisse direkt einzusehen.',
'bt_no_report_yet': 'Kein Bericht verfügbar',
'bt_no_addons': 'Mit diesem Laborbesuch wurden keine Add-On-Pakete bestellt',
'bt_omega_insight_label': 'Einblick',
'bt_omega_chart_section_title': 'Dein Profil: Fettsäuren Zusammensetzung',
'bt_omega_chart_omega3': 'Omega-3',
'bt_omega_chart_omega6': 'Omega-6',
'bt_omega_chart_mufa': 'MUFA',
'bt_omega_chart_sfa': 'SFA',
'bt_omega_chart_total_label': 'Fettsäuren',
'bt_omega_chart_no_data': 'Daten zur Fettsäurezusammensetzung für diesen Laborbesuch nicht verfügbar.',
'bt_omega_abbrev_pufa': 'PUFA = Mehrfach ungesättigte Fettsäuren = Omega-3 + Omega-6 Fettsäuren',
'bt_omega_abbrev_mufa': 'MUFA = Einfach ungesättigte Fettsäuren',
'bt_omega_abbrev_sfa':  'SFA = Gesättigte Fettsäuren',
'bt_omega_intro_text': 'Dein Gesundheitszustand hängt maßgeblich von einer ausgewogenen Ernährung ab. Fette sind Teil einer gesunden Ernährung. Achte auf Gesamtmenge und vor allem auf die Zusammensetzung deines Fettsäuren Profils.',
'bt_omega_balanced_chart_title': 'Ein sehr ausgewogenes Profil',
'bt_omega_balanced_chart_sub': 'Vergleiche dein Verteilungsmuster mit diesem ausgewogenen Profil.',
'bt_omega_guidelines_title': 'Ernährungsrichtlinien',
'bt_omega_guideline_1': 'Achte auf genügend Zufuhr von Omega-3 Fettsäuren (8-12%)',
'bt_omega_guideline_2': 'Achte speziell auf den Omega-3-Index (EPA & DHA), der über 8% liegen sollte',
'bt_omega_guideline_3': 'Achte auf das Verhältnis Omega-6 zu Omega-3 Fettsäuren, das unter 5 liegen sollte, besser unter 3',
'bt_omega_guideline_4': 'Du verbesserst deine Ernährung, wenn du den Anteil Einfachungesättigter Fettsäuren (MUFA) erhöhst und den Anteil an Gesättigten Fettsäuren (SFA) im Gegenzug senkst.',
'omega_key_ratios_title': 'Wichtigste Marker',
'omega_markers_title': 'Deine Fettsäuren-Marker',
'omega_key_insights_title': 'Deine wichtigsten Erkenntnisse',
'omega_key_insights_pending': 'Personalisierte Einblicke zu deinem Omega-Profil erscheinen hier, sobald sie verfügbar sind.',
'omega_function_title': 'Was das für deinen Körper bedeutet',
'omega_function_pending': 'Personalisierte Auswertungen für diesen Bereich sind noch nicht verfügbar.',
'omega_function_heart': 'Herzgesundheit',
'omega_function_brain': 'Gehirn & Kognition',
'omega_function_inflammation': 'Entzündungsbalance',
'omega_function_eyes': 'Augengesundheit',
'omega_actions_title': 'Personalisierte Maßnahmen',
'omega_actions_pending': 'Personalisierte, priorisierte Empfehlungen erscheinen hier, sobald sie verfügbar sind.',
'omega_hero_eyebrow': 'Dein Omega-3-Index',
'omega_hero_explainer': 'Der Index zeigt, wie viel der Omega-3-Fettsäuren EPA und DHA in die Hüllen deiner roten Blutkörperchen eingebaut ist. Deshalb steht er für deine Versorgung über längere Zeit und nicht für die letzte Mahlzeit.',
'omega_state_below': 'unter dem Laborbereich',
'omega_state_above': 'über dem Laborbereich',
'omega_state_below_opt': 'im Laborbereich, unter dem Optimalbereich',
'omega_state_above_opt': 'im Laborbereich, über dem Optimalbereich',
'omega_state_optimal': 'im Optimalbereich',
'omega_state_normal': 'im Laborbereich',
'omega_range_lab': 'Labor',
'omega_range_optimal': 'Optimal',
'omega_range_from': 'ab',
'omega_range_upto': 'bis',
'omega_legend_ref': 'Referenzbereich',
'omega_legend_opt': 'Optimalbereich',
'omega_card_desc_EPA': 'Omega-3-Fettsäure, vor allem aus fettem Seefisch',
'omega_card_desc_DHA': 'Baustein von Gehirn und Netzhaut',
'omega_card_desc_ALA': 'die pflanzliche Omega-3-Form',
'omega_card_desc_RATIO63': 'das Verhältnis der beiden Fettsäure-Familien',
'omega_bei_dir': 'Bei dir',
'omega_eyebrow_body': 'Dein Körper',
'omega_eyebrow_steps': 'Deine nächsten Schritte',
'omega_report_loading': 'Dein Omega-3-Report wird geladen',
'omega_report_pending_title': 'Dein persönlicher Omega-3-Report ist noch in Arbeit',
'omega_report_error_title': 'Report konnte nicht geladen werden',
'omega_report_error': 'Dein persönlicher Omega-3-Report ist gerade nicht abrufbar. Bitte lade die Seite später neu.',
'bt_questionnaire_empty': 'Keine Antworten verfügbar',
'quest_select_date': 'Datum auswählen',
'quest_new_btn': 'Neuen Fragebogen ausfüllen',
'quest_new_drawer_title': 'Neuer Fragebogen',
'quest_new_success': 'Fragebogen erfolgreich eingereicht!',
'quest_answered': 'beantwortet',
'bt_cycle_status': 'Zyklus-Status',
'bt_cycle_day': 'Tag {n} von 28',
'bt_raw_report_download': 'Labor Rohbericht Download',
'bt_labvisit_1': 'Laborbesuch 1',
'bt_labvisit_2': 'Laborbesuch 2',
'bt_labvisit_3': 'Laborbesuch 3',
'bt_labvisit_4': 'Laborbesuch 4',
'bt_in_range': 'NORMAL',
'bt_out_of_range': 'ABNORMAL',
'bt_results_header': 'Laborbesuch Ergebnisse',
'bt_legend_optimal': 'Optimal',
'bt_legend_normal': 'Normal',
'bt_core_result_header': 'Ergebnisse des Core Health Bluttest Nr.',
'bt_addon_result_header': 'Ergebnisse der bestellten Add-ons',
'bt_visit_date': 'Laborbesuch-Datum:',
'bt_tab_addons': 'Bestellte Zusatzpakete',
'bt_sub_active': 'Aktiv',
'bt_sub_inactive': 'Nicht aktiv',
'bt_in_progress': 'In Bearbeitung',
'bt_no_visits': 'Keine Laborbesuche gefunden.',
'bt_no_results_yet': 'Für diesen Termin liegen noch keine Ergebnisse vor.',
'bt_results_error': 'Ergebnisse konnten nicht geladen werden. Bitte später erneut versuchen.',
'bt_labvisit': 'Laborbesuch',
'bt_your_subscription': 'Dein Abonnement:',
'bt_lab': 'Labor:',
'bt_tooltip_out_of_range': 'Außerhalb des Laborreferenzbereichs',
'bt_tooltip_all_in_range': 'Alle Marker innerhalb des Laborreferenzbereichs',
'bt_not_ordered': 'Nicht bestellt',
'bt_consider_addon': 'Erwägen Sie dieses Add-On bei Ihrem nächsten Laborbesuch.',

// ── BLUTTESTS · Kategoriebeschriftungen ──────────────────────
'bt_cat_core_membership':             'Core Health Bluttest',
'bt_cat_arteriosclerosis_prevention': 'Atherosklerose Prävention',
'bt_cat_omega_health':                'Omega-Gesundheit',
'bt_cat_hormones':                    'Hormone',
'bt_cat_bones_health':                'Knochengesundheit',
'bt_cat_vitamins_nutrients':          'Vitamine & Nährstoffe',
'bt_cat_thyroid_health':              'Schilddrüsengesundheit',
'bt_cat_fertility_female':            'Fruchtbarkeit (Frau)',
'bt_cat_prostate_cancer_prevention':  'Prostatakrebs-Prävention',
'bt_cat_colon_cancer_prevention':     'Darmkrebs-Prävention',

// ── BLUTTESTS · Statusbeschriftungen ─────────────────────────
'bt_status_normal':        'NORMAL',
'bt_status_low':           'NIEDRIG',
'bt_status_high':          'HOCH',
'bt_status_critical_low':  'NIEDRIG',
'bt_status_critical_high': 'HOCH',
'bt_chart_history':        'Wertverlauf',
'bt_chart_title':          'Wertverlauf',
'bt_chart_no_data':        'Keine historischen Daten für diesen Marker vorhanden.',
'bt_chart_ref_range':      'Referenzbereich',
'bt_chart_value':          'Wert',
'bt_chart_unit':           'Einheit',
'bt_chart_col_marker':     'Marker',
'bt_chart_col_date':       'Datum',
'bt_chart_col_value':      'Wert',
'bt_chart_col_unit':       'Einheit',
'bt_chart_col_trend':      'Trend',
'bt_chart_col_status':     'Status',
'bt_chart_sub1':           'Referenzbereich wird aus dem aktuellsten Labortermins angezeigt',
'bt_chart_sub2':           'Statusfarbe bezieht sich auf die Laborreferenzwerte',
'bt_chart_source_user':    'Sie',
'bt_tooltip_view_detail':  'Detailseite anzeigen',
'horm_profile_label':          'Hormonstatus',
'horm_profile_cycletracker':   'Zyklustracking',
'horm_profile_perimenopause':  'Perimenopause',
'horm_profile_postmenopause':  'Postmenopause',
'horm_status_hormonal_bc':     'Hormonelle Verhütung',
'horm_status_hrt':             'Hormonersatztherapie (HRT)',
'horm_cycle_day':              'Tag',
'horm_cycle_day_label':        'Laborbesuch Tag & Zyklus:',
'horm_phase_menstrual':        'Menstruation',
'horm_phase_follicular':       'Follikelphase',
'horm_phase_ovulatory':        'Ovulationsphase',
'horm_phase_luteal':           'Lutealphase',
'horm_profile_not_set':        'Noch kein Hormonstatus hinterlegt',
'horm_profile_setup_cta':      'Profil einrichten',
'horm_info_dialog_title':      'Über deinen Hormonstatus',
'horm_info_profiles_heading':  'Profilzustände',
'horm_info_cycletracker_title':'Zyklustracking',
'horm_info_cycletracker_text': 'Du verfolgst deinen natürlichen Menstruationszyklus. Die Hormondiagramme zeigen Referenzkurven über 28 Zyklustage, und dein Laborwert wird am Zyklustag deines Besuchs eingetragen.',
'horm_info_perimenopause_title':'Perimenopause',
'horm_info_perimenopause_text':'Du befindest dich im Menopausalübergang. Je nach Datenlage stehen sowohl zyklusbasierte als auch Übergangsstadien-Diagramme zur Verfügung.',
'horm_info_postmenopause_title':'Postmenopause',
'horm_info_postmenopause_text':'Du bist postmenopausal. Die Diagramme zeigen Referenzkurven über die vier Stadien des Menopausalübergangs.',
'horm_info_hormonal_bc_title': 'Hormonelle Verhütung',
'horm_info_hormonal_bc_text':  'Du verwendest hormonelle Verhütung. Die Diagramme spiegeln das supprimierte Hormonumfeld wider, und für jeden Marker wird verhütungsspezifischer Kontext angezeigt.',
'horm_info_hrt_title':         'Hormonersatztherapie (HRT)',
'horm_info_hrt_text':          'Du nimmst HRT. Die Diagramme zeigen sowohl die natürliche postmenopausale Kurve als auch ein HRT-Referenzband, damit du erkennen kannst, wie deine Therapie mit den erwarteten Bereichen vergleicht.',
'horm_info_charts_heading':    'Wie dein Profil die Anzeige bestimmt',
'horm_info_charts_text':       'Dein Profil bestimmt, welche Referenzkurven, Kontexttexte und klinischen Hinweise für jeden Hormonmarker erscheinen. Zyklustracking zeigt tagesspezifische Kurven über den Menstruationszyklus; Perimenopause und Postmenopause zeigen Übergangskurven. Fruchtbarkeitshinweise, Verhütungshinweise und HRT-Hinweise werden nur angezeigt, wenn sie für deinen Profilzustand klinisch relevant sind.',
'horm_info_selfservice_heading': 'Profil ändern',
'horm_info_selfservice_text':    'Wenn dein Profilzustand nicht deiner aktuellen Situation entspricht, kannst du ihn selbst anpassen. Gehe zu Administration → Persönliche Daten → Weibliches Gesundheitsprofil und wähle den richtigen Zustand aus. Änderungen werden sofort wirksam und aktualisieren alle Hormoncharts.',
'horm_biomarkers_badge':         'Biomarker',
'horm_marker_overview_heading':  'Hormonmarker - Übersicht',
'horm_section_glycoprotein':     '(Glyco-) Proteinhormone',
'horm_section_steroid':          'Steroidhormone',
'horm_panel_title':              'Hormonmarker - Einblicke',
'horm_panel_subtitle':           'Wähle einen Marker für persönliche Einblicke',
'horm_ai_summary_label':         'KI-Zusammenfassung',
'horm_summary_wellbeing_title':  'Wie du dich jetzt fühlst — aus deinen Ergebnissen',
'horm_summary_mood':             'Stimmung',
'horm_summary_energy':           'Energie',
'horm_summary_libido':           'Libido',
'horm_summary_pain':             'Schmerz',
'horm_summary_doctor':           'Mit dem Arzt besprechen',
'horm_rep_summary_title':        'Das Wichtigste',
'horm_rep_for_you':              'Bei dir',
'horm_rep_for_you_actions':      'Für dich',
'horm_rep_androgens_kicker':     'Im Zusammenspiel',
'horm_rep_androgens_title':      'Testosteron, SHBG und DHEA-S',
'horm_rep_body_kicker':          'Dein Körper',
'horm_rep_body_title':           'Was deine Hormone für dich bedeuten',
'horm_rep_actions_kicker':       'Deine nächsten Schritte',
'horm_rep_actions_title':        'Was helfen könnte',
'horm_rep_discuss_kicker':       'Arztgespräch',
'horm_rep_discuss_title':        'Themen fürs Gespräch',
'horm_topic_beschwerden_dieser_phase':     'Beschwerden dieser Phase',
'horm_topic_sexualitaet_und_wohlbefinden': 'Sexualität und Wohlbefinden',
'horm_topic_knochen_und_muskeln':          'Knochen und Muskeln',
'horm_topic_stoffwechsel_und_gefaesse':    'Stoffwechsel und Gefäße',
'bt_add_value_title':      'Historischen Wert eintragen',
'bt_add_value_subtitle':   'Werte aus früheren Laborbefunden eingeben',
'bt_add_value_subtitle2':  'Wert bei Bedarf in die vorausgefüllte Einheit umrechnen',
'bt_add_value_marker':     'Marker',
'bt_add_value_unit':       'Einheit',
'bt_add_value_date':       'Datum',
'bt_add_value_value':      'Wert',
'bt_add_value_ref_low':    'Referenz Untergrenze (optional)',
'bt_add_value_ref_high':   'Referenz Obergrenze (optional)',
'bt_add_value_submit':     'Eintrag speichern',
'bt_add_value_duplicate':  'Für diesen Marker existiert bereits ein Eintrag an diesem Datum.',
'bt_add_value_error':      'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
'bt_add_value_success':    'Wert erfolgreich hinzugefügt',

// ── HORMONZYKLUS-CHART ────────────────────────────────────────
'hcc_title':               'Hormone und Zyklus',
'hcc_day':                 'Tag',
'hcc_select_marker':       'Marker auswählen:',
'hcc_latest_result':       'Aktuelles Ergebnis',
'hcc_no_data':             'Keine Messdaten vorhanden — nur Referenzkurven',
'hcc_role_E2':             'Stimmung & Energie',
'hcc_role_P4':             'Ruhe & Schlaf',
'hcc_role_LH':             'Ovulationsauslöser',
'hcc_role_FSH':            'Ovariales Signal',
'hcc_insight_E2_NORMAL':   'Ihr Östrogen unterstützt einen gesunden Zyklusrhythmus.',
'hcc_insight_E2_LOW':      'Niedrigeres E2 kann zu trockenen Tagen oder gedrückter Stimmung beitragen.',
'hcc_insight_E2_HIGH':     'Erhöhtes E2 kann zu Brustspannungen oder stärkerer Regelblutung führen.',
'hcc_insight_P4_NORMAL':   'Ihre Werte sind in dieser Zyklusphase gut ausgewogen.',
'hcc_insight_P4_LOW':      'Niedriges P4 in der Lutealphase kann Schmierblutungen oder PMS-Angstzustände verursachen.',
'hcc_insight_P4_HIGH':     'Starke Progesteronwerte deuten in der Regel auf eine gesunde Ovulation hin.',
'hcc_insight_FSH_NORMAL':  'Die ovarielle Kommunikation liegt im typischen Bereich.',
'hcc_insight_FSH_LOW':     'Normal in Ihrer Phase; das Signal zwischen Gehirn und Eierstöcken ist ruhig.',
'hcc_insight_FSH_HIGH':    'Ein steigendes FSH deutet darauf hin, dass Ihre Eierstöcke ein stärkeres Signal brauchen — ein wichtiger Übergangsmarker.',
'hcc_insight_LH_NORMAL':   'Ihr Hypophysensignal verhält sich wie erwartet.',
'hcc_insight_LH_LOW':      'Typisch außerhalb des engen Ovulationsfensters.',
'hcc_insight_LH_HIGH':     'Hohes LH kann die Eizellqualität beeinträchtigen oder auf ein hormonelles Ungleichgewicht hinweisen.',

// ── MENOPAUSE-HORMON-CHART ────────────────────────────────────
'mhc_title':               'Hormone und Perimenopause / Menopause',
'mhc_select_marker':       'Marker auswählen:',
'mhc_latest_result':       'Aktuelles Ergebnis',
'mhc_what_means':          'Was das für Sie bedeutet',
'mhc_phase_peri':          'Perimenopause',
'mhc_phase_menopause':     'Menopause',
'mhc_phase_postmeno':      'Postmenopause',
'mhc_legend_range':        'Referenzbereich',
'mhc_legend_mean':         'Typischer Mittelwert',
'mhc_legend_hrt':          'Mit HRT',
'mhc_hrt_label':           'MIT HRT',
'mhc_role_fsh':            'Ovariales Signal',
'mhc_role_lh':             'Ovulationsauslöser',
'mhc_role_e2':             'Stimmung & Energie',
'mhc_role_p4':             'Ruhe & Schlaf',
'mhc_status_expected':     'ERWARTET',
'mhc_status_therapeutic':  'THERAPEUTISCH',
// fsh
'mhc_fsh_EXPECTED_title':  'Ihr FSH bestätigt den postmenopausalen Status',
'mhc_fsh_EXPECTED_text':   'Ein FSH im postmenopausalen Bereich ist ein normales, dauerhaftes Merkmal dieser Phase. Ihre Hypophyse sendet starke Signale, da die Eierstöcke nicht mehr reagieren — dies ist zu erwarten und bedarf keiner Behandlung. Standardmäßige HRT unterdrückt FSH nicht nennenswert.',
'mhc_fsh_HIGH_title':      'Ihr FSH ist erhöht — konsistent mit der Menopause',
'mhc_fsh_HIGH_text':       'Ein hoher FSH-Wert zeigt an, dass Ihre Eierstöcke kein Östrogen mehr produzieren. Dies ist in der Postmenopause normal. Wenn Sie noch keine HRT machen, besprechen Sie mit Ihrer Ärztin, ob eine Hormontherapie für Sie geeignet ist.',
'mhc_fsh_NORMAL_title':    'Ihr FSH liegt im Normalbereich',
'mhc_fsh_NORMAL_text':     'Ihr FSH liegt im Referenzbereich für Ihre aktuelle Phase. Dies ist ein beruhigendes Signal, dass die Hormonsteuerkommunikation wie erwartet funktioniert.',
'mhc_fsh_LOW_title':       'Ihr FSH ist niedriger als erwartet',
'mhc_fsh_LOW_text':        'Ein niedriges FSH in der Postmenopause kann auf eine HRT-Unterdrückung oder einen anderen hormonellen Einfluss hinweisen. Sprechen Sie mit Ihrer Ärztin, falls dies bei Ihrer aktuellen Behandlung unerwartet ist.',
// lh
'mhc_lh_EXPECTED_title':   'Ihr LH liegt im erwarteten postmenopausalen Bereich',
'mhc_lh_EXPECTED_text':    'Erhöhtes LH ist ein dauerhaftes, erwartetes Merkmal der Postmenopause. Es spiegelt das Fehlen der ovariellen Rückmeldung wider — kein Hypophysenproblem. HRT hat minimalen Effekt auf LH, daher ist dieser Wert auch unter Therapie normal.',
'mhc_lh_HIGH_title':       'Ihr LH ist erhöht',
'mhc_lh_HIGH_text':        'Erhöhtes LH in der Postmenopause ist zu erwarten und bedarf keiner Behandlung. Es spiegelt das anhaltende — aber unbeantwortete — Signal des Körpers an die Eierstöcke wider.',
'mhc_lh_NORMAL_title':     'Ihr LH liegt im Normalbereich',
'mhc_lh_NORMAL_text':      'Ihr LH liegt im Referenzbereich für Ihre Phase und zeigt eine stabile Hypophysensignalgebung.',
'mhc_lh_LOW_title':        'Ihr LH ist niedriger als erwartet',
'mhc_lh_LOW_text':         'Ein niedriges LH in der Postmenopause ist ungewöhnlich und sollte mit Ihrer Ärztin besprochen werden, insbesondere wenn Sie Medikamente nehmen, die die Hypophysenfunktion beeinflussen könnten.',
// e2
'mhc_e2_THERAPEUTIC_title': 'Ihr Östrogen liegt im therapeutischen Bereich',
'mhc_e2_THERAPEUTIC_text':  'Ihr E2-Wert ist konsistent mit einer effektiven HRT-Aufnahme. Dieser Bereich unterstützt Knochendichte, Herzgesundheit, Stimmung und kognitive Funktion. Die Aufrechterhaltung des Östrogenspiegels auf diesem Niveau ist eines der Hauptziele der HRT in der Postmenopause.',
'mhc_e2_LOW_title':         'Ihr Östrogen liegt unter dem therapeutischen Zielwert',
'mhc_e2_LOW_text':          'Ein niedriges E2 bei HRT kann bedeuten, dass Ihre aktuelle Dosis oder Verabreichungsform nicht effektiv absorbiert wird. Häufige Ursachen sind Pflasterplatzierung, Hautprobleme oder Körperzusammensetzung. Besprechen Sie eine Dosisanpassung mit Ihrer Ärztin — Symptome wie Hitzewallungen oder Schlafstörungen könnten damit zusammenhängen.',
'mhc_e2_HIGH_title':        'Ihr Östrogen liegt über dem typischen therapeutischen Bereich',
'mhc_e2_HIGH_text':         'Ein E2 über dem therapeutischen Zielwert kann bei höheren HRT-Dosen oder starker Absorption auftreten. Obwohl dies nicht unbedingt schädlich ist, sollte Ihre Ärztin die Dosierung überprüfen, um sicherzustellen, dass sie auf Ihre Bedürfnisse abgestimmt ist.',
'mhc_e2_NORMAL_title':      'Ihr Östrogen liegt im normalen postmenopausalen Bereich',
'mhc_e2_NORMAL_text':       'Ihr E2 liegt im typischen postmenopausalen Bereich. Wenn Sie keine HRT machen, spiegelt dies die natürliche Produktion aus der peripheren Umwandlung von Androgenen wider. Bei Beschwerden sprechen Sie mit Ihrer Ärztin, ob eine HRT helfen könnte.',
// p4
'mhc_p4_LOW_title':         'Ihr Progesteron liegt unter dem therapeutischen Zielwert',
'mhc_p4_LOW_text':          'Ein P4 unter 5 ng/ml bei oralem Progesteron (200 mg) deutet darauf hin, dass die Dosis möglicherweise nicht vollständig absorbiert wird. Der Zeitpunkt der Blutabnahme ist wichtig — idealerweise 2–4 Stunden nach der Einnahme. Niedriges P4 kann die Schlafqualität beeinträchtigen und, bei vorhandenem Uterus, möglicherweise keinen ausreichenden Gebärmutterschutz bieten. Sprechen Sie mit Ihrer Ärztin.',
'mhc_p4_THERAPEUTIC_title': 'Ihr Progesteron liegt im therapeutischen Bereich',
'mhc_p4_THERAPEUTIC_text':  'Ihr P4 liegt im erwarteten Bereich für eine orale Progesteronsupplementation. Dies unterstützt die Schlafqualität, reduziert Angstzustände und schützt die Gebärmutterschleimhaut, wenn Sie auch Östrogen nehmen.',
'mhc_p4_HIGH_title':        'Ihr Progesteron liegt über dem typischen Bereich',
'mhc_p4_HIGH_text':         'Ein P4 über 20 ng/ml bei Standard-Oralprogesteron ist höher als typisch und könnte mit dem Zeitpunkt der Blutabnahme zusammenhängen (Messung des Spitzenwertes kurz nach der Einnahme). Sprechen Sie mit Ihrer Ärztin, wenn dies bei mehreren Messungen konsistent ist.',
'mhc_p4_NORMAL_title':      'Ihr Progesteron liegt im Normalbereich',
'mhc_p4_NORMAL_text':       'Nachweisbares P4 in der Postmenopause spiegelt in der Regel eine HRT-Supplementierung wider. Ihr Wert liegt im erwarteten Bereich für Ihre aktuelle Phase.',
'mhc_p4_EXPECTED_title':    'Progesteron nahe Null — ohne HRT erwartet',
'mhc_p4_EXPECTED_text':     'Ein Progesteron nahe Null ist der natürliche postmenopausale Zustand. Wenn Sie einen Uterus haben und Östrogen nehmen, ist eine Progesteronsupplementation wichtig, um die Gebärmutterschleimhaut zu schützen. Sprechen Sie mit Ihrer Ärztin, falls dies noch nicht besprochen wurde.',

// ── Historische Laborbefunde ────────────────────────────────────────────────
'lab_page_hl':              'Gesundheitsakte - ',
'lab_page_sp':              'Historische Laborbefunde',
'lab_nav_item':             'Historische Laborbefunde',
'lab_dash_title':           'Historische Laborbefunde',
'lab_dash_subtitle':        'Laden Sie Ihre persönlichen Laborbefunde hoch und verwalten Sie diese. Verwenden Sie Tags um verschiedene Dokumente zu gruppieren.',
'lab_btn_upload_report':    'Befund hochladen',
'lab_quota_storage':        'Speicher:',
'lab_quota_mb_of':          'MB von',
'lab_quota_mb_used':        'MB verwendet',
'lab_quota_mb_free':        'MB frei',
'lab_loading':              'Laborbefunde werden geladen…',
'lab_empty_title':          'Noch keine Laborbefunde vorhanden',
'lab_empty_body':           'Laden Sie Ihre historischen Laborbefunde hoch – Bilder (JPEG, PNG) oder PDF-Dateien',
'lab_empty_btn':            'Ersten Befund hochladen',
'lab_dia_upload_title':     'Laborbefund hochladen',
'lab_field_title_label':    'Berichtstitel',
'lab_field_title_ph':       'z.B. Blutbild März 2024',
'lab_field_date_label':     'Berichtsdatum',
'lab_field_tags_label':     'Tags',
'lab_field_tags_ph':        'z.B. Schilddrüsen-OP',
'lab_drop_idle':            'Dateien hier ablegen oder klicken zum Durchsuchen',
'lab_drop_active':          'Dateien hier ablegen…',
'lab_drop_hint':            'PDF, JPEG, PNG, GIF, WebP · max. 10 MB pro Datei · mehrere Dateien möglich',
'lab_files_ready':          'Datei bereit zum Hochladen',
'lab_files_ready_pl':       'Dateien bereit zum Hochladen',
'lab_uploading':            'Wird hochgeladen…',
'lab_err_validation':       'Bitte Titel, Datum und mindestens eine Datei angeben.',
'lab_err_file_rejected':    'Eine oder mehrere Dateien wurden nicht hinzugefügt — unterstützt werden nur PDF, JPEG, PNG, GIF, WebP bis 10 MB.',
'lab_err_upload':           'Hochladen fehlgeschlagen.',
'lab_err_load':             'Laborbefunde konnten nicht geladen werden.',
'lab_err_delete':           'Löschen fehlgeschlagen.',
'lab_err_tag_save':         'Tags konnten nicht gespeichert werden.',
'lab_err_tag_no_doc':       'Kein Dokument ausgewählt — bitte den Tags-bearbeiten-Dialog erneut öffnen.',
'lab_btn_cancel':           'Abbrechen',
'lab_btn_upload_submit':    'Hochladen',
'lab_btn_view':             'Ansehen',
'lab_btn_edit_tags':        'Tags bearbeiten',
'lab_btn_tag_save':         'Speichern',
'lab_tag_edit_title':       'Tags bearbeiten',
'lab_tag_no_options':       'Tippen, um einen neuen Tag zu erstellen',
'lab_filter_all':           'Alle',
'lab_manage_tags_btn':      'Tags verwalten',
'lab_manage_tags_title':    'Tags verwalten',
'lab_manage_tags_empty':    'Noch keine Tags vorhanden.',
'lab_tag_rename_btn':       'Umbenennen',
'lab_err_tag_rename':       'Tag konnte nicht umbenannt werden.',
'lab_err_tag_delete':       'Tag konnte nicht gelöscht werden.',
'lab_tag_del_title':        'Tag löschen?',
'lab_tag_del_body':         'Dieser Tag wird von allen Dokumenten entfernt, die ihn verwenden. Diese Aktion kann nicht rückgängig gemacht werden.',
'lab_pdf_pages':            'PDF-Seiten',
'lab_pdf_doc':              'PDF-Dokument',
'lab_pdf_page_aria':        'PDF-Seite',
'lab_del_title':            'Laborbefund löschen?',
'lab_del_body':             'Dieser Befund und alle zugehörigen Seiten werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
'lab_del_btn':              'Löschen',
'lab_deleting':             'Wird gelöscht…',
'lab_chip_img':             'Bild',
'lab_chip_img_pl':          'Bilder',
'lab_chip_pdf':             'PDF',
'lab_chip_pdf_pl':          'PDFs',
'lab_chip_page':            'Seite',
'lab_chip_page_pl':         'Seiten',
'lab_info_title':           'Upload-Tipps',
'lab_info_p1':              'Reduzieren Sie die Dateigröße von Dokumentfotos vor dem Hochladen. Das Scannen von Dokumenten erzeugt in der Regel kleinere Dateien als reguläre Fotos.',
'lab_info_p2_intro':        'Zum Beispiel auf einem Apple iPhone:',
'lab_info_p2_step1':        'Öffnen Sie die Dateien-App.',
'lab_info_p2_step2':        'Tippen Sie auf das ⋯ Menü.',
'lab_info_p2_step3':        'Wählen Sie „Dokumente scannen".',
'lab_info_p2_step4':        'Scannen Sie die Seiten und speichern Sie sie als PDF.',
'lab_info_p3':              'PDF-Scans sind oft viel kleiner und leichter hochzuladen als hochauflösende Fotos.',
'lab_info_p4':              'Versuchen Sie, die Kameraauflösung für zukünftige Dokumentfotos zu reduzieren. Überprüfen Sie auch die aktuelle Dateigröße vor dem Hochladen.',

"vitals_body_shape":        "Körperform & BMI",
"vitals_markers":           "MARKER",
"vitals_blood_pressure":    "Blutdruck",
"vitals_bp_ref":            "Ref: ~120 / 80 mmHg",
"vitals_height":              "Körpergröße",
"vitals_weight":              "Gewicht",
"vitals_bmi":                 "BMI - Body Mass Index",
"vitals_waist":               "Taillenumfang",
"vitals_weight_ref":          "Basierend auf BMI",
"vitals_bmi_ref":             "normal: 18,5 – 25",
"vitals_waist_ref_m":         "Referenz < 102 cm",
"vitals_waist_ref_f":         "Referenz < 88 cm",
"vitals_whtr":                "Taille-Größe-Verhältnis",
"vitals_whtr_ref":            "Referenz < 0,5",
"vitals_whtr_info_title":     "Waist-to-Height Ratio",
"vitals_whtr_info_body":      "Der Waist-to-Height Ratio ist eine anthropometrische Größe, die eine Aussage über die Menge und Verteilung des Körperfetts macht. Je höher sein Wert ist, desto größer ist das kardiovaskuläre Risiko. In einer Studie mit rund 11.000 Teilnehmern erwies sich der WHtR als besserer prognostischer Parameter für kardiovaskuläre Erkrankungen wie Herzinfarkt oder Schlaganfall als der Body-Mass-Index (BMI). Der kritische Grenzwert für Menschen < 40 Jahre liegt bei einem WHtR von 0,5.",
"vitals_set_height":          "Größe eingeben",
"vitals_height_dialog_title": "Körpergröße aktualisieren",
"vitals_height_dialog_body":  "Ihre Körpergröße wird für die BMI-Berechnung benötigt. Bitte geben Sie Ihre Körpergröße in Zentimetern ein.",
"vitals_height_label":        "Körpergröße (cm)",
"vitals_height_save":         "Speichern",
"vitals_height_success":      "Körpergröße erfolgreich gespeichert",
"vitals_height_error":        "Bitte geben Sie eine gültige Körpergröße zwischen 50 und 250 cm ein",
"vitals_height_save_error":   "Körpergröße konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
"vitals_add_weight":          "Gewicht hinzufügen",
"vitals_add_measurement":     "Messung hinzufügen",
"vitals_weight_chart":        "Gewichtsverlauf",
"vitals_bmi_chart":           "BMI Verlauf",
"vitals_waist_chart":         "Taillenumfang Verlauf",
"vitals_no_chart_data":       "Keine Daten verfügbar",
"vitals_date":                "Datum",
"vitals_prefilled":           "Aus letztem Eintrag vorausgefüllt",
"vitals_save_success":        "Erfolgreich gespeichert",
"vitals_unit":                "Einheit",
"vitals_status_high":         "HOCH",
"vitals_status_low":          "NIEDRIG",
"vitals_chart_target":        "Ziel",
"vitals_fill_all_fields":     "Bitte alle Felder ausfüllen.",
"vitals_save_error_generic":  "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",

"vitals_info_title":      "Körperliche Grundwerte – BMI und Taillenumfang",
"vitals_info_intro":      "Heute gibt es zwei Methoden der Selbsteinschätzung, die Ihnen ein klareres Bild davon vermitteln können, wie Ihr Gewicht Ihre Gesundheit beeinflussen könnte – die Messung Ihres Taillenumfangs und die Berechnung Ihres Body-Mass-Index (BMI). Der Body-Mass-Index (BMI) ist ein Maß für den Körperfettanteil basierend auf Größe und Gewicht, das für erwachsene Männer und Frauen gilt. Berechnen Sie Ihren BMI selbst: Teilen Sie Ihr Gewicht in Kilogramm durch das Quadrat Ihrer Körpergröße in Metern.",
"vitals_info_bmi_heading": "Warum ist der BMI wichtig?",
"vitals_info_bmi_body":   "Der BMI (Body-Mass-Index) ist ein nützliches Maß für Übergewicht und Fettleibigkeit. Er wird aus Ihrer Körpergröße und Ihrem Gewicht berechnet. Je höher Ihr BMI, desto höher ist Ihr Risiko für bestimmte Krankheiten wie Herzerkrankungen, Bluthochdruck, Typ-2-Diabetes, Gallensteine, Atemprobleme und sogar bestimmte Krebsarten. Ein gesunder BMI-Wert liegt zwischen 18,5 und 25; ein BMI über 30 gilt als Adipositas mit hohem Krankheitsrisiko. Es ist sinnvoll, den Taillenumfang in die Beurteilung Ihres Gewichts und Gesundheitsrisikos einzubeziehen. Neben Übergewicht oder Adipositas erhöhen folgende Faktoren Ihr Risiko für Herzerkrankungen und andere Erkrankungen: Bluthochdruck, erhöhter LDL-Cholesterinspiegel (schlechtes Cholesterin), niedriger HDL-Cholesterinspiegel (gutes Cholesterin), erhöhte Triglyceride, erhöhter Blutzucker, familiäre Vorbelastung für frühe Herzerkrankungen, körperliche Inaktivität, Rauchen. Die gute Nachricht: Bereits ein geringer Gewichtsverlust (zwischen 5 und 10 Prozent Ihres aktuellen Gewichts) kann Ihr Risiko, diese Erkrankungen zu entwickeln, senken.",
"vitals_info_wc_heading":  "Warum ist mein Taillenumfang wichtig?",
"vitals_info_wc_body":    "Der Taillenumfang (TU) ist ein Maß zur Schätzung des subkutanen und viszeralen Bauchfetts. Höhere Werte (über 102 cm bei Männern und über 88 cm bei Frauen) sind mit einem erhöhten Risiko für Typ-2-Diabetes, erhöhten Blutcholesterin, Bluthochdruck und Herzerkrankungen verbunden. Verschiedene Faktoren beeinflussen die Verteilung des viszeralen Fettgewebes, darunter BMI, Alter, Geschlecht sowie ethnische Zugehörigkeit.",
"vitals_info_apple_pear":  "Apfel oder Birne? Wo Sie Ihr Gewicht tragen, ist genauso wichtig wie das Gewicht selbst, wenn es um Ihre Gesundheit geht.",
"vitals_info_source":      "Quelle",

"vitals_bp_7day_avg":      "7-Tage-Durchschnitt",
"vitals_bp_systole":       "Systole",
"vitals_bp_diastole":      "Diastole",
"vitals_bp_time_of_day":   "Tageszeit",
"vitals_bp_morning":       "Morgens",
"vitals_bp_noon":          "Mittags",
"vitals_bp_evening":       "Abends",
"vitals_bp_chart_title":   "Blutdruck-Verlauf",
"vitals_bp_add_title":     "Blutdruck hinzufügen",
"vitals_bp_chart_sys":     "Systolisch",
"vitals_bp_chart_dia":     "Diastolisch",
"vitals_bp_col_time":      "Zeit",
"vitals_bp_info_title":    "Warum ist Blutdruck so wichtig?",
"vitals_bp_info_p1":       "Blutdruck ist der Druck, der gegen die Arterienwände ausgeübt wird, wenn das Herz Blut pumpt. Hoher Blutdruck dehnt die Arterien über ein gesundes Maß hinaus.",
"vitals_bp_info_p2":       "Bluthochdruck betrifft die meisten Menschen, insbesondere Erwachsene über 65 Jahre. Chronische Überdehnung der Arterien hat viele negative Folgen wie Risse und Narbenbildung, brüchige Stellen, Blutgerinnsel, erhöhte Herzbelastung und Plaquebildung.",
"vitals_bp_info_ht":       "Hypertonie-Risiken",
"vitals_bp_info_p3":       "Bluthochdruck erhöht Ihr Risiko für Schlaganfall, Herzinfarkt oder Herzinsuffizienz. Normaler systolischer Blutdruck liegt unter 120 mmHg, normaler diastolischer Blutdruck unter 80 mmHg. Hypertonie Stufe 2 mit hohem Risiko liegt über 140/90 mmHg.",
"vitals_bp_info_p4":       "Ernährungs- und Lebensstiländerungen können Ihren Blutdruck senken. Essen Sie viel Gemüse, Obst und Vollkornprodukte, mageres Protein, fettarme Milchprodukte und Nüsse. Begrenzen Sie gesättigte Fette, Zucker und Junk Food. Erhöhen Sie Kalium und reduzieren Sie Natrium (unter 2300 mg/Tag). Ergänzen Sie mit Vitamin C (500 mg/Tag).",
"vitals_bp_info_source":   "(Quelle: Linus Pauling Institut)",
"vitals_bp_status_elevated": "ERHÖHT",
"vitals_bp_7day_count":      "Messungen in den letzten 7 Tagen",
"vitals_ref":                "Referenz",

// ── USER ADMIN — Profil & Passwort ───────────────────────────
"ua_profile_headline":       "KONTOEINSTELLUNGEN",
"ua_profile_subtext":        "Persönliche Daten aktualisieren. Die Änderung der E-Mail-Adresse erfordert eine erneute Verifizierung.",
"ua_profile_first_name":     "Vorname",
"ua_profile_last_name":      "Nachname",
"ua_profile_username":       "Benutzername",
"ua_profile_email":          "E-Mail-Adresse",
"ua_profile_phone":          "Telefonnummer",
"ua_profile_phone_ph":       "+436641234567",
"ua_profile_language":       "Sprache",
"ua_profile_height":         "Größe (cm)",
"ua_profile_save":           "Änderungen speichern",
"ua_profile_load_error":     "Profil konnte nicht geladen werden.",
"ua_profile_update_error":   "Aktualisierung fehlgeschlagen. Bitte erneut versuchen.",
"ua_profile_success":        "Profil erfolgreich aktualisiert.",
"ua_female_headline":        "WEIBLICHES GESUNDHEITSPROFIL",
"ua_female_subtext":         "Ihr Hormonstatus hilft uns, die richtigen Referenzbereiche für Ihre Laborergebnisse anzuwenden. Bitte wählen Sie den Status, der Ihren aktuellen hormonellen Kontext am besten beschreibt.",
"ua_female_profile_label":   "Hormonstatus",
"ua_female_opt_cycletracker":    "Aktiver Menstruationszyklus",
"ua_female_opt_perimenopause":   "Perimenopause",
"ua_female_opt_postmenopause":   "Postmenopause",
"ua_female_opt_birthcontrol":    "Hormonelle Verhütung",
"ua_female_status_label":        "Hormonstatus",
"ua_female_status_normal":       "Normal",
"ua_female_status_hormonal_birth_control": "Hormonelle Verhütung",
"ua_female_status_hrt":          "Hormonersatztherapie (HRT)",
"ua_female_save":            "Profil speichern",
"ua_female_load_error":      "Weibliches Gesundheitsprofil konnte nicht geladen werden.",
"ua_female_update_error":    "Speichern fehlgeschlagen. Bitte erneut versuchen.",
"ua_female_success":         "Weibliches Gesundheitsprofil erfolgreich gespeichert.",
"ua_pw_headline":            "PASSWORT - ",
"ua_pw_subtext":             "ÄNDERN",
"ua_pw_dash_header":         "PASSWORT ÄNDERN",
"ua_pw_dash_subline":        "In diesem Bereich kannst du dein Passwort ändern. Das neue Passwort gilt ab deiner nächsten Anmeldung. Starke Passwörter schützen dein Konto – ändere sie regelmäßig. Ein starkes Passwort ist lang, zufällig (eine Mischung aus Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen) und einzigartig. Passwörter müssen mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
"ua_pw_dash_subline_gen":    "Nutze den Passwort-Generator (Zauberstab-Symbol), um automatisch ein starkes Passwort zu erstellen — kopiere es in die Zwischenablage oder übernehme es direkt in die Felder mit dem Pfeil-Symbol.",
"ua_pw_dash_subline_sec":    "Dein Passwort regelmäßig zu ändern ist eine der wirksamsten Maßnahmen zum Schutz deines Kontos. Selbst wenn deine Zugangsdaten durch einen Datenschutzverstoß ohne dein Wissen kompromittiert wurden, begrenzt ein aktuelles Passwort das Risikofenster erheblich. Wir empfehlen, dein Passwort alle 3 bis 6 Monate zu aktualisieren.",
"ua_pw_new":                 "Neues Passwort",
"ua_pw_new_repeat":          "Neues Passwort wiederholen",
"ua_pw_old":                 "Altes Passwort",
"ua_pw_submit":              "Absenden",
"ua_pw_gen_suggest":         "Starkes Passwort vorschlagen",
"ua_pw_gen_copy":            "Kopieren",
"ua_pw_gen_apply":           "In Felder übernehmen",
"ua_pw_gen_copied":          "Kopiert!",
"ua_pw_success":             "Dein Passwort wurde erfolgreich geändert",
"ua_pw_error":               "Bitte Eingaben überprüfen.",

"addon_purchases_headline":  "ADD-ON KÄUFE",
"addon_subtext":             "Hier findest du alle deine Add-On-Käufe, die du für deine Laborbesuche ausgewählt hast. Die Add-On-Käufe sind nach dem Zahlungsdatum und dem Erstellungsdatum gruppiert. Für alle Add-On-Käufe hast du außerdem eine E-Mail mit einer Zusammenfassung deiner Auswahl sowie einem Download-Link für die Rechnung erhalten.",
"addon_selected_for":        "Ausgewählte Add-Ons —",
"addon_hide":                "Ausblenden",
"addon_view":                "Anzeigen",
"addon_orders_label":        "Add-Ons",
"addon_status_paid":         "Bezahlt",
"addon_status_unpaid":       "Unbezahlt",
"addon_total_vat":           "Gesamt Add-Ons inkl. 20% MwSt.",
"addon_invoice":             "Rechnung",
"addon_no_purchases":        "Noch keine Add-On-Käufe.",
"addon_fetch_error":         "Add-On-Käufe konnten nicht geladen werden.",

"sub_headline":              "MITGLIEDSCHAFT",
"sub_subtext":               "In diesem Bereich findest du detaillierte Informationen zu deinem aktuellen Abonnement. Das Abo wird jährlich automatisch verlängert. Du kannst deinen Plan upgraden, downgraden, kündigen oder fortsetzen gemäß den Nutzungsbedingungen.",
"sub_manage_headline":       "MITGLIEDSCHAFT VERWALTEN",
"sub_change_subtext":        "Du kannst deinen Abonnementplan upgraden, downgraden, kündigen oder fortsetzen gemäß den Nutzungsbedingungen.",
"sub_status_active":         "Aktiv",
"sub_status_inactive":       "Inaktiv",
"sub_billing_period":        "Abrechnungszeitraum",
"sub_price":                 "Preis",
"sub_per_year":              "/ Jahr",
"sub_cancels_at_period_end": "Kündigt zum Periodenende",
"sub_change_plan":           "Plan ändern",
"sub_cancel":                "Abo kündigen",
"sub_resume":                "Abo fortsetzen",
"sub_change_plan_dialog":    "Abonnementplan ändern",
"sub_confirm_change":        "Änderung bestätigen",
"sub_fetch_error":           "Abonnementdaten konnten nicht geladen werden.",
"sub_action_error":          "Aktion fehlgeschlagen. Bitte erneut versuchen.",
"sub_plan_change_error":     "Planänderung fehlgeschlagen. Bitte erneut versuchen.",
"sub_no_plan":               "Du hast aktuell kein aktives Abonnement.",
"sub_proration_notice":      "Die Planänderung wird sofort wirksam. Stripe berechnet die Differenz anteilig, wodurch dein Zahlungsmittel sofort belastet oder gutgeschrieben werden kann.",
"sub_plan2_name":            "Mitgliedschaft - 2x testen / Jahr, Zahlung jährlich",
"sub_plan3_name":            "Mitgliedschaft - 4x testen / Jahr, Zahlung jährlich",
"sub_plan4_name":            "Mitgliedschaft - 2x testen / Jahr, Zahlung monatlich",
"sub_plan5_name":            "Mitgliedschaft - 4x testen / Jahr, Zahlung monatlich",

"invoices_headline":             "RECHNUNGEN",
"invoices_subtext":              "Hier findest du alle Rechnungen zu deinem Abonnement und deinen Add-On-Käufen.",
"invoices_empty":                "Noch keine Rechnungen.",
"invoices_view":                 "Anzeigen",
"invoices_download":             "Herunterladen",
"invoices_load_more":            "Mehr laden",
"invoices_status_paid":          "Bezahlt",
"invoices_status_open":          "Offen",
"invoices_status_void":          "Storniert",
"invoices_status_uncollectible": "Uneinbringlich",
"invoices_status_draft":         "Entwurf",
"invoices_type_subscription":    "Abo",
"invoices_type_addon":           "Add-On",
"invoices_fetch_error":          "Rechnungen konnten nicht geladen werden.",

"pay_headline":              "ZAHLUNGSMETHODE ÄNDERN",
"pay_subtext":               "Hier kannst du deine Standard-Zahlungsmethode ändern. In den meisten Fällen erneuerst du deine Kreditkarte rechtzeitig vor Ablauf.",
"pay_current_method":        "Aktuelle Zahlungsmethode",
"pay_card_fallback":         "Karte",
"pay_exp":                   "Ablauf",
"pay_status_active":         "Aktiv",
"pay_status_error":          "Fehler",
"pay_no_method":             "Keine Zahlungsmethode hinterlegt",
"pay_change_card":           "Karte ändern",
"pay_update_method_dialog":  "Zahlungsmethode aktualisieren",
"pay_update_card":           "Karte aktualisieren",
"pay_update_error":          "Fehler beim Aktualisieren der Karte. Bitte erneut versuchen.",

// ── GUIDED TOUR ──────────────────────────────────────────────────────────────
'tour_welcome_title':     'Willkommen bei deinem Gesundheits-Cockpit!',
'tour_welcome_body1':     'Ärztlich geprüft, wissenschaftlich aufbereitet — damit du deinen Körper wirklich verstehst, nicht nur seine Zahlen.',
'tour_welcome_body2':     'In den nächsten Minuten zeigen wir dir Schritt für Schritt, was du wo findest — und was deine Werte für deine Gesundheit bedeuten.',
'tour_welcome_cta':       'Tour starten',
'tour_welcome_skip':      'Überspringen',

'tour_closing_title':     'Du kennst jetzt dein Cockpit!',
'tour_closing_body':      'Starte mit deiner ersten Empfehlung — klein anfangen, konsequent bleiben. Dein Körper wird es dir danken.',
'tour_closing_brand1':    'Wir haben speak23 so aufgebaut, weil wir glauben: Wer seinen Körper wirklich versteht, kann die besten Entscheidungen für seine Gesundheit treffen. Nimm dir Zeit, deine Daten zu verstehen — du selbst bist der wichtigste Teil davon.',
'tour_closing_brand2':    'Die Zukunft der Medizin liegt in der Prävention. Und du hast gerade den ersten Schritt gemacht.',
'tour_closing_hint':      'Diese Tour jederzeit wieder starten — über das ? in der Seitenleiste.',
'tour_closing_cta':       'Zum Cockpit →',

'tour_step_nav_title':    'Navigationsleiste öffnen & schliessen',
'tour_step_nav_body':     'Mit dieser Schaltfläche oben links neben dem Logo öffnest und schliesst du die Navigationsleiste. Über die Navigation erreichst du alle Bereiche der speak23 Software.',
'tour_step_sections_title':  'Die 4 Bereiche der Navigation',
'tour_step_sections_body':   'Die Navigationsleiste ist in 4 Bereiche gegliedert:',
'tour_step_sections_item1':  'Steuere deine Gesundheit – Cockpit, Empfehlungen, Arztgespräch und biologisches Alter',
'tour_step_sections_item2':  'Testergebnisse – alle Laborwerte und detaillierte Analysen',
'tour_step_sections_item3':  'Weitere Apps für deine Gesundheit – Körper, Zyklus, Medikamente',
'tour_step_sections_item4':  'Administration – Laborbesuche, Abonnement und Kontoeinstellungen',
'tour_step0_title':       'Die 12 Mechanismen deiner Gesundheit',
'tour_step0_body':        'Dein Körper wird in vier Bereichen betrachtet: Stoffwechsel, Immunsystem, Organe und Mikronährstoffe. Zu jedem Bereich zeigt dir das Cockpit die wichtigsten Mechanismen — so siehst du auf einen Blick, wie es dir dort gerade geht.',
'tour_step1_title':       'So liest du deine Risiko-Punkte',
'tour_step1_body':        'Die Punkte neben jedem Begriff zeigen deinen persönlichen Risikowert. Wenige grüne Punkte bedeuten: kein Handlungsbedarf. Je mehr Punkte ausgefüllt sind — vor allem in Orange — desto mehr verdient dieser Bereich deine Aufmerksamkeit. Über den Pfeil öffnest du die für dich erstellte Auswertung zu jedem Mechanismus.',
'tour_step2_title':       'Deine persönlichen Empfehlungen',
'tour_step2_highlight':   'Fange mit deiner ersten Empfehlung an — sie hat die höchste Priorität und den größten Hebel für deine Gesundheit.',
'tour_step2_body':        'Deine Empfehlungen haben eine eigene Seite in der Navigation. Versuche dich bis zum nächsten Test auf genau diese eine Sache zu konzentrieren. Klein anfangen und konsequent bleiben — das macht den Unterschied.',
'tour_step3_title':       'Mit dem Arzt sprechen',
'tour_step3_body':        'Auch diese Seite erreichst du über die Navigation. Hier findest du fertige Fragen für deinen nächsten Arzttermin — direkt aus deinen Laborwerten abgeleitet. So gehst du gut vorbereitet ins Gespräch und weißt genau, worüber es sich lohnt zu sprechen.',
'tour_step5_title':       'Deine Add-on Analysen',
'tour_step5_body':        'Falls du Hormone, Omega oder Darm-Mikrobiom dazugebucht hast, findest du deine persönlichen Ergebnisse hier.',
'tour_step5_highlight':   'Für Frauen, die ihren Zyklus mittracken wollen: Achte darauf, deinen Zyklus-Tracker aktuell zu halten — nur so werden deine Laborwerte in der richtigen Zyklusphase interpretiert. Das ist der Schlüssel zu einer wirklich personalisierten Analyse, und etwas, das in der Medizin leider oft untergeht.',
'tour_step7_title':       'Alle deine Laborwerte',
'tour_step7_body':        'Hier findest du jeden einzelnen Wert aus deinem Labortest — mit Referenzbereich und Status. Du musst nicht alles im Detail verstehen: Das Cockpit hat das Wichtigste bereits für dich aufbereitet. Wenn du aber tiefer eintauchen möchtest, ist hier alles zu finden.',
'tour_step8_title':       'Dein biologisches Alter',
'tour_step8_body':        'Dein biologisches Alter zeigt, wie alt dein Körper wirklich ist — unabhängig von deinem Geburtsdatum.',
'tour_step8_highlight':   'Zahlreiche starke wissenschaftliche Studien belegen: Ein niedriges biologisches Alter ist einer der stärksten Prädiktoren für eine höhere Lebenserwartung und mehr gesunde Lebensjahre.',
'tour_step8_goal':        'Halte dein biologisches Alter unter deinem Kalenderalter — oder senke es, falls es aktuell zu hoch ist. Die Wissenschaft bestätigt das eindeutig.',

'tour_btn_back':          '← Zurück',
'tour_btn_close':         'Schließen',
'tour_btn_last':          'Fertig',
'tour_btn_next':          'Weiter →',
'tour_btn_next_with_progress': 'Weiter ({current} von {total})',
'tour_btn_open':          'Tour öffnen',
'tour_restart_label':     'Tour starten',

// ── FEEDBACK ───────────────────────────────────────
'page_hl_feedback': 'FEEDBACK - ',
'page_sp_feedback': 'DEIN FEEDBACK',
'feedback_header': 'Dein Feedback',
'feedback_subheader': 'Vielen Dank dafür, dass du speak23 ausgewählt und das Vertrauen geschenkt hast!\nWir versuchen, die speak23 Lösung ständig zu verbessern und zu erweitern. Dein Feedback ist für uns daher ein wichtiger Input für unsere Weiterentwicklung.',
'feedback_answered_label': 'beantwortet',
'feedback_submit': 'Feedback absenden',
'feedback_submitting': 'Wird gesendet…',
'feedback_thank_you': 'Danke für dein Feedback',
'feedback_already_title': 'Du hast dein Feedback bereits übermittelt. Keine weitere Aktion erforderlich.',

// ── GIFT REDEMPTION ──────────────────────────────────────────
'gift_redeem_headline': 'Du hast ein Geschenk erhalten',
'gift_redeem_from': 'Von',
'gift_redeem_for': 'Für',
'gift_redeem_valid_until': 'Einlösbar bis',
'gift_redeem_button': 'Geschenk einlösen',
'gift_redeem_not_found': 'Dieser Geschenk-Link ist ungültig. Bitte prüfe den Link in deiner E-Mail.',
'gift_redeem_load_error': 'Das Geschenk konnte nicht geladen werden. Bitte versuche es später erneut.',
'gift_redeem_already_redeemed': 'Dieses Geschenk wurde bereits eingelöst.',
'gift_redeem_not_payable': 'Dieses Geschenk kann nicht eingelöst werden.',
'gift_redeem_expired': 'Die Einlösefrist für dieses Geschenk ist abgelaufen.',
'gift_redeem_error': 'Das Geschenk konnte nicht eingelöst werden. Bitte versuche es erneut.',
'gift_redeem_auth_title': 'Löse dein Geschenk ein mit ein paar einfachen Schritten:',
'gift_redeem_step_1': 'Lege bitte ein Konto an („Registrieren“)',
'gift_redeem_step_2': 'Melde dich mit deinen Zugangsdaten an',
'gift_redeem_step_3': 'Du wirst durch das Onboarding geführt (Termin für Laborbesuch, Fragebogen)',
'gift_redeem_auth_closing': 'Viel Erfolg!',
'gift_redeem_register': 'Konto erstellen',
'gift_redeem_success_title': 'Geschenk eingelöst',
'gift_redeem_success_text': 'Dein speak23-Zugang ist aktiv bis',
'gift_redeem_continue': 'Weiter',

};
